const loginMap = {
  // 用户注册
  userRegister: '/usb/uwb-app/api/v1/user/register',
  // 用户登录
  userLogin: '/usb/uwb-app/api/v1/user/login',
  // 忘记密码
  forgetPassword: '/usb/uwb-app/api/v1/user/forgetPassword',
  // 发送WhatsApp登录验证码
  sendWhatsAppLoginCode: '/usb/uwb-app/api/v1/user/sendWhatsAppLoginCode',
  // 检查手机号是否注册
  checkPhoneNumberIsRegister: '/usb/uwb-app/api/v1/user/checkPhoneNumber',

  // 退出登录
  logoutExt: '/usb/uwb-app/api/v1/user/loginOut',

  // 注销账号
  logOff: '/usb/uwb-app/api/v1/user/unregister',
};

export default loginMap;
